// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__EvisB","location":"Header_location__1DX1M"};